<div
  class="flex items-center gap-2 py-2 px-3 rounded-full w-fit bg-shikenso-gray-base cursor-pointer select-none hover:bg-shikenso-gray-base-60 active:bg-shikenso-purple-base-12"
  [class.opacity-50]="disabled()"
  [class.cursor-not-allowed]="disabled()"
  [class.pointer-events-none]="disabled()"
  [ngClass]="containerClasses()"
  (click)="onPillClick()"
>
  <div class="flex items-center gap-2" [ngClass]="labelContainerClasses()">
    @if (icon()) {
      <app-icon-badge
        backgroundColor="transparent"
        [content]="icon()"
        [size]="32"
        [iconSize]="32"
        [fontSize]="16"
        [borderRadius]="100"
      />
    }

    @if (platform()) {
      <app-social-badge backgroundColor="transparent" [type]="platform()!" [size]="16" [iconSize]="16" />
    }

    <span [ngClass]="labelClasses()">{{ label() }}</span>
  </div>

  @if (checked()) {
    <app-icon src="icons/circle-check.svg" alt="check" color="var(--shikenso-success-bright)" [size]="24" />
  } @else {
    <app-icon src="icons/circle.svg" alt="circle" [size]="24" />
  }
</div>
